
export default (function (change) {
  window.scrollBy(change.x, change.y);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-beautiful-dnd/esm/view/window/scroll-window.js
// module id = 1223
// module chunks = 0